// extracted by mini-css-extract-plugin
module.exports = {"container":"EditAccount_container__1Nlnd","columnContainer":"EditAccount_columnContainer__3Xyv0","column":"EditAccount_column__2nOS6","alignTop":"EditAccount_alignTop__CsYcp"};